var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_vm._v("\n  Abnormal data acquisition, please rescan the QR code\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }